/* eslint-disable no-nested-ternary */
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-empty-pattern */
import * as yup from "yup";
import moment from "moment";
import { CoverType, partners } from "src/config/constant";
import {
  ExistingLifeCover,
  IExistingLifeCover,
  ILoan,
  // IPaymentDetails,
  // IPaymentDetails,
  IPlan,
  IPremiumDetails,
  IPremiumFunding,
  LoanDetails,
  PRODUCT_ID
} from "../ProposalDetails/interfaces";
import regex from "../../regex";
import { findKeysByValue } from "../ProposalDetails/resources";

const existingLifeCoverInitialValuesObject: IExistingLifeCover = {
  acceptanceTerms: "",
  acceptanceTermsCode: "",
  nameOfInsuranceCompany: "",
  nameOfInsuranceCompanyCode: "",
  policyNumber: "",
  totalSumInsured: ""
};

export const ShareOfLoanOptions = ["Greater than 50%", "Less Than Or Equal To 50%"];

const initialValues: LoanDetails = {
  loan: {
    lifeCoverOption: "",
    loanType: "",
    loanAcNo: "",
    interestPeriod: "No",
    moratoriumPeriodWith: "",
    moratoriumPeriodWithout: "",
    emiAmount: "",
    emiFrequency: "",
    lifeAssuredShareOfLoan: "",
    loanTerm: "",
    loanAmount: "",
    noOfCoBorrowers: 0,
    share: "",
    loanInterestRate: "",
    dateOfDisbursement: "",
    lipAccNo: "",
    lifeCoverOptionCode: "",
    loanTermCode: "",
    loanTypeCode: "",
    moratoriumPeriodWithCode: "",
    moratoriumPeriodWithoutCode: ""
  },
  plan: {
    coverOption: "",
    deathSumInsured: "",
    coverTerm: "",
    premiumPaymentTerm: "",
    coverOptionCode: "",
    coverTermCode: "",
    premiumPaymentTermCode: ""
  },
  premiumDetails: {
    premiumMode: "",
    totalPayment: "",
    premiumModeCode: ""
  },
  premiumFunding: {
    premiumFunding: "",
    premiumFundingCode: ""
  },
  // payment: {
  //   paymentMethod: "",
  //   chequeNo: "",
  //   chequeDate: "",
  //   bankName: "",
  //   branchName: "",
  //   amount: ""
  // },
  existingPolicy: {
    existingLifeCover: false,
    existingPolicyDetails: [existingLifeCoverInitialValuesObject]
  }
};

const existingLifeCoverValidation = (productId: any) =>
  yup.array().when("existingLifeCover", {
    is: true,
    then: (schema) =>
      schema.of(
        yup.object().shape<Record<keyof IExistingLifeCover, yup.AnySchema>>({
          acceptanceTerms: yup
            .string()
            .required("Acceptance Terms is Required")
            .matches(regex.alphabetWithSpace, "Invalid Acceptance Terms"),
          nameOfInsuranceCompany: yup
            .string()
            .required("Insurance Company Name is Required")
            .matches(regex.alphabetWithSpace, "Invalid Name of Insurance Company"),
          policyNumber: yup
            .string()
            .required("Policy/ Application No. is Required")
            .matches(regex.digits, "Invalid Policy/ Application No.")
            .max(8, "Max 8 digit allowed"),
          totalSumInsured: yup
            .string()
            .when("productId", ([prodId], innerSchema) =>
              [PRODUCT_ID.GHS, PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GHS_IDBI]?.includes(productId)
                ? innerSchema
                    .required("Total Sum Assured is Required")
                    .matches(regex.digitfifteenDigitbeforeDecimal, "Invalid Total Sum Assured")
                : innerSchema
                    .required("Total Sum Assured is Required")
                    .matches(regex.digits, "Invalid Total Sum Assured")
                    .max(10, "Max 10 digit allowed")
            ),
          nameOfInsuranceCompanyCode: yup.string(),
          acceptanceTermsCode: yup.string()
        })
      ),
    otherwise: (schema) => schema.notRequired()
  });

const partnerLoanInterestSchema: Record<string, (schema: yup.StringSchema) => yup.StringSchema> = {
  [partners.SREI]: (schema) =>
    schema
      .matches(regex.loanInterestRateFormat, "Invalid Loan Interest Rate")
      .test("min-max-srei", "Loan Interest Rate must be between 11 and 18", (value) => {
        const numValue = parseFloat(value ?? "");
        return numValue >= 11 && numValue <= 18;
      })
      .test("multiple-of-0.5", "Loan Interest Rate must be in multiples of 0.5", (value) => {
        const numValue = parseFloat(value ?? "");
        return Number.isFinite(numValue) && (numValue * 10) % 5 === 0;
      }),

  [partners.JIO]: (schema) =>
    schema
      .matches(regex.loanIntersetRate, "Invalid Loan Interest Rate")
      .test(
        "min-max",
        "Loan Interest Rate must be between 8 and 12",
        (value: string | undefined) => {
          const numValue = parseFloat(value ?? "");
          return numValue >= 8 && numValue <= 12;
        }
      ),

  default: (schema) =>
    schema.matches(regex.digitThreeDigitbeforeDecimal, "Invalid Loan Interest Rate")
};

const validationSchema = (
  noOfCoBorrowersError: string,
  productId: any,
  coverOption: string,
  partnerId: any,
  { planDetailsMefFields, loanDetailsMefFields }: any
) =>
  yup.object().shape<Record<keyof LoanDetails, yup.AnySchema>>({
    loan: yup.object().shape<Record<keyof ILoan, yup.AnySchema>>({
      dateOfDisbursement: yup
        .string()
        .max(10, "Invalid Date")
        .test("is-valid-date", "Invalid date", (value) =>
          moment(value, "DD/MM/YYYY").isSameOrBefore(new Date())
        )
        .when([], (_, schema) =>
          loanDetailsMefFields?.disbursementDate?.required
            ? schema.required("Date Of Disbursement is Required")
            : schema
        ),
      emiAmount: yup
        .string()
        .default("")
        .matches(regex.SevenDigitsUpto2Precision, "Invalid EMI Amount")
        .test("not-zero", "Invalid EMI Amount", (value) => parseFloat(value) !== 0)
        .when([], (_, schema) =>
          loanDetailsMefFields?.emiAmount?.required
            ? schema.required("EMI Amount is Required")
            : schema
        ),
      emiFrequency: yup
        .string()
        .when([], (_, schema) =>
          loanDetailsMefFields?.emiFrequency?.required
            ? schema.required("EMI Frequency is Required")
            : schema
        ),
      lifeAssuredShareOfLoan: yup
        .string()
        .when([], (_, schema) =>
          loanDetailsMefFields?.lifeAssuredShareOfLoan?.required
            ? schema.required("Life Assured Share Of Loan is Required")
            : schema
        ),
      lifeCoverOption: yup.string().required("Life Cover Option is Required"),
      lipAccNo: yup
        .string()
        .matches(regex.digits, "Invalid LIP Account No")
        .max(30, "Max 30 digits allowed")
        .when([], (_, schema) =>
          loanDetailsMefFields?.lipAccountNo?.required
            ? schema.required("LIP Account No is Required")
            : schema.notRequired()
        ),
      loanAcNo: yup
        .string()
        .matches(regex.loanAcNo, "Invalid Loan A/C No")
        .max(20, "Max 20 digits allowed")
        .when([], (_, schema) =>
          loanDetailsMefFields?.loanAccountNo?.required
            ? schema.required("Loan A/C No is Required")
            : schema.notRequired()
        ),
      loanAmount: yup.string().when([], (_, schema) => {
        const baseSchema =
          partnerId === partners.JIO
            ? schema.matches(regex.loanAmountRegex, "Loan Amount b/w 3L to 10cr")
            : schema.matches(regex.digits, "Invalid Loan Amount").max(10, "Max 10 digits allowed");
        return loanDetailsMefFields?.loanAmount?.required
          ? baseSchema.required("Loan Amount is Required")
          : baseSchema.notRequired();
      }),
      // loanInterestRate: yup
      //   .string()
      //   .required("Loan Interest Rate is Required")
      //   .matches(regex.digitsUpto2Precision, "Invalid Loan Interest Rate")
      //   .max(3, "Max 3 digits allowed"),

      // loanInterestRate: yup
      //   .string()
      //   .transform((value) => {
      //     if (typeof value !== "string" || value.trim() === "") return value;
      //     const num = parseFloat(value);
      //     if (!Number.isFinite(num)) return value;
      //     const rounded = Math.ceil(num * 2) / 2; // round up to next 0.5
      //     return rounded.toFixed(1);
      //   })

      //   .when("lifeCoverOptionCode", ([lifeCoverOptionCode], schema) => {
      //     if (lifeCoverOptionCode === "reducing") {
      //       const baseSchema =
      //         partnerId === partners.SREI
      //           ? schema
      //               .matches(regex.loanIntersetRate, "Invalid Loan Interest Rate")
      //               .test(
      //                 "min-max-srei",
      //                 "Loan Interest Rate must be between 12 and 18",
      //                 (value) => {
      //                   const numValue = parseFloat(value ?? "");
      //                   return numValue >= 12 && numValue <= 18;
      //                 }
      //               )
      //               .test(
      //                 "multiple-of-0.5",
      //                 "Loan Interest Rate must be in multiples of 0.5",
      //                 (value) => {
      //                   const numValue = parseFloat(value ?? "");
      //                   return Number.isFinite(numValue) && (numValue * 10) % 5 === 0;
      //                 }
      //               )
      //           : partnerId === partners.JIO
      //           ? schema
      //               .matches(regex.loanIntersetRate, "Invalid Loan Interest Rate")
      //               .test("min-max", "Loan Interest Rate must be between 8 and 12", (value) => {
      //                 const numValue = parseFloat(value ?? "");
      //                 return numValue >= 8 && numValue <= 12;
      //               })
      //           : schema.matches(regex.digitThreeDigitbeforeDecimal, "Invalid Loan Interest Rate");
      //       const withZeroCheck = baseSchema.test(
      //         "not-zero",
      //         "Invalid Loan Interest Rate",
      //         (value) => value !== "0"
      //       );
      //       return loanDetailsMefFields?.loanInterestRate?.required
      //         ? withZeroCheck.required("Loan Interest Rate is Required")
      //         : withZeroCheck.notRequired();
      //     }
      //     return schema.notRequired();
      //   }),

      loanInterestRate: yup
        .string()
        .transform((value) => {
          if (typeof value !== "string" || value.trim() === "") return value;
          const num = parseFloat(value);
          if (!Number.isFinite(num)) return value;
          const rounded = Math.ceil(num * 2) / 2;
          return rounded.toFixed(1);
        })
        .when("lifeCoverOptionCode", ([lifeCoverOptionCode], schema) => {
          if (lifeCoverOptionCode !== "reducing") {
            return schema.notRequired();
          }

          let baseSchema = (
            partnerLoanInterestSchema[partnerId] || partnerLoanInterestSchema.default
          )(schema);
          baseSchema = baseSchema.test(
            "not-zero",
            "Invalid Loan Interest Rate",
            (value) => value !== "0"
          );
          return loanDetailsMefFields?.loanInterestRate?.required
            ? baseSchema.required("Loan Interest Rate is Required")
            : baseSchema.notRequired();
        }),
      loanTerm: yup
        .string()
        .matches(regex.digits, "Invalid Loan Term")
        .max(3, "Max 3 digits allowed")
        .when([], (_, schema) =>
          loanDetailsMefFields?.term?.required
            ? schema.required("Loan Term is Required")
            : schema.notRequired()
        ),
      loanType: yup
        .string()
        .when([], (_, schema) =>
          loanDetailsMefFields?.loanType?.required
            ? schema.required("Loan Type is Required")
            : schema.notRequired()
        ),
      interestPeriod: yup
        .string()
        .when([], (_, schema) =>
          loanDetailsMefFields?.interestAccruals?.required
            ? schema.required("Internal Accruals is Required")
            : schema.notRequired()
        ),
      moratoriumPeriodWith: yup
        .string()
        .when(["lifeCoverOptionCode", "productId"], ([lifeCoverOptionCode, prodId], schema) =>
          lifeCoverOptionCode === "reducing" || productId === PRODUCT_ID.GLS
            ? schema.test(
                "moratoriumPeriodWith",
                "Moratorium Period With Interest is Required",
                function (value, helpers) {
                  const { moratoriumPeriodWith, loanTerm } = helpers.parent;
                  const isLoanTermGreaterThanMoratorium =
                    Number(loanTerm) > Number(moratoriumPeriodWith / 12);
                  return isLoanTermGreaterThanMoratorium && value
                    ? true
                    : this.createError({ message: "Moratorium should be less than Loan Term" });
                }
              )
            : schema.when([], (_, innerSchema) =>
                loanDetailsMefFields?.moratoriumPeriod?.required
                  ? innerSchema.required("Moratorium Period With Interest is Required")
                  : innerSchema.notRequired()
              )
        ),
      moratoriumPeriodWithout: yup
        .string()
        .when("lifeCoverOptionCode", ([lifeCoverOptionCode], schema) =>
          lifeCoverOptionCode === "reducing"
            ? schema.when([], (_, innerSchema) =>
                loanDetailsMefFields?.moratoriumPeriod?.required
                  ? innerSchema.required("Moratorium Period Without Interest is Required")
                  : innerSchema.notRequired()
              )
            : schema.notRequired()
        ),
      noOfCoBorrowers: yup.string().when("coverOption", ([_], schema) =>
        coverOption === CoverType.PROPORTIONATE
          ? schema
              .required("Number Of Co-Borrowers is Required")
              .matches(regex.numberWithoutPreceedingZero, "Invalid No Of CoBorrowers")
              .test("is-valid-noOfCoBorrowers", noOfCoBorrowersError, () => !noOfCoBorrowersError)
          : schema.notRequired()
      ),
      share: yup.string().when("coverOption", ([_], schema) =>
        coverOption === CoverType.PROPORTIONATE
          ? schema.required("Share % is Required")
          : // .matches(regex.numeric, "Invalid Share Of Loan%")
            schema.notRequired()
      ),
      lifeCoverOptionCode: yup.string(),
      loanTypeCode: yup.string(),
      moratoriumPeriodWithCode: yup.string(),
      moratoriumPeriodWithoutCode: yup.string(),
      loanTermCode: yup.string()
    }),
    plan: yup.object().shape<Record<keyof IPlan, yup.AnySchema>>({
      coverOption: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.coverOption?.required
            ? schema.required("Cover Option is Required")
            : schema.notRequired()
        ),
      coverTerm: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.coverTerm?.required
            ? schema.required("Cover Term is Required")
            : schema.notRequired()
        ),
      deathSumInsured: yup
        .string()
        .matches(regex.digits, "Invalid Death Sum Assured")
        .min(5, "Min 5 digits allowed")
        .max(10, "Max 10 digits allowed")
        .when([], (_, schema) =>
          planDetailsMefFields?.deathSumAssured?.required
            ? schema.required("Death Sum Assured is Required")
            : schema.notRequired()
        ),

      premiumPaymentTerm: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.premiumPaymentTerm?.required
            ? schema.required("Premium Payment Term is Required")
            : schema.notRequired()
        ),
      coverOptionCode: yup.string(),
      coverTermCode: yup.string(),
      premiumPaymentTermCode: yup.string()
    }),
    premiumDetails: yup.object().shape<Record<keyof IPremiumDetails, yup.AnySchema>>({
      premiumMode: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.premiumDetails?.required
            ? schema.required("Premium Mode is Required")
            : schema.notRequired()
        ),
      totalPayment: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.totalPayment?.required
            ? schema.required("Total Payment is Required")
            : schema.notRequired()
        ),
      // .matches(regex.tenDigitsUpto2PrecisionWithoutZero, "Invalid Total Payment"),
      premiumModeCode: yup.string()
    }),
    premiumFunding: yup.object().shape<Record<keyof IPremiumFunding, yup.AnySchema>>({
      premiumFunding: yup
        .string()
        .when([], (_, schema) =>
          planDetailsMefFields?.premiumFunding?.required
            ? schema.required("Premium Funding is Required")
            : schema.notRequired()
        ),
      premiumFundingCode: yup.string()
    }),
    // payment: yup.object().shape<Record<keyof IPaymentDetails, yup.AnySchema>>({
    //   amount: yup.string().required("Please enter Amount").matches(regex.digits, "Invalid Amount"),
    //   paymentMethod: yup.string().required("Please select Payment Method"),
    //   bankName: yup
    //     .string()
    //     .when("paymentMethod", ([paymentMethod], schema) =>
    //       paymentMethod === "Cheque"
    //         ? schema.required("Please enter Cheque Date")
    //         : schema.notRequired()
    //     ),
    //   branchName: yup
    //     .string()
    //     .when("paymentMethod", ([paymentMethod], schema) =>
    //       paymentMethod === "Cheque"
    //         ? schema.required("Please enter Cheque Date")
    //         : schema.notRequired()
    //     ),
    //   chequeDate: yup
    //     .string()
    //     .when("paymentMethod", ([paymentMethod], schema) =>
    //       paymentMethod === "Cheque"
    //         ? schema.required("Please enter Cheque Date")
    //         : schema.notRequired()
    //     ),
    //   chequeNo: yup
    //     .string()
    //     .when("paymentMethod", ([paymentMethod], schema) =>
    //       paymentMethod === "Cheque"
    //         ? schema.required("Please enter Cheque Number")
    //         : schema.notRequired()
    //     )
    // }),
    existingPolicy: yup.object().shape<Record<keyof ExistingLifeCover, yup.AnySchema>>({
      existingLifeCover: yup.boolean(),
      existingPolicyDetails: existingLifeCoverValidation(productId)
    })
  });

const getDifference = (a: any, b: any) =>
  Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val));

const getPremiumChangeDetails = (fieldValues: any, loanDetails: any, masterReducer: any) => {
  const loanDiff = getDifference(loanDetails.loan, fieldValues.loan);
  const planDiff = getDifference(loanDetails.plan, fieldValues.plan);
  const premiumDiff = getDifference(loanDetails.premiumDetails, fieldValues.premiumDetails);
  const fundingDiff = getDifference(loanDetails.premiumFunding, fieldValues.premiumFunding);

  const differentObj = {
    ...loanDiff,
    ...planDiff,
    ...premiumDiff,
    ...fundingDiff
  };

  const madeObj: any = {};
  const keys = Object.keys(differentObj);

  if (keys.length > 0) {
    keys.forEach((key: any) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      // console.log(`${key}: ${differentObj[key]} ${typeof differentObj[key]}`);
      if (key === "lifeCoverOption") {
        madeObj.coverOption = findKeysByValue(masterReducer.coverOption, String(differentObj[key]));
      } else if (key === "loanType") {
        madeObj.loanCategory = findKeysByValue(
          masterReducer.loanCategory,
          String(differentObj[key])
        );
      } else if (key === "loanAcNo") {
        madeObj.loanAccountNo = differentObj[key];
      } else if (key === "moratoriumPeriodWith") {
        madeObj.moratoriumPeriod = Number(differentObj[key]);
      } else if (key === "moratoriumPeriodWithout") {
        madeObj.moratoriumPeriodWithoutInterest = Number(differentObj[key]);
      } else if (key === "loanTerm") {
        madeObj.term = Number(differentObj[key]);
      } else if (key === "share") {
        madeObj.shareOfLoanPerc = Number(differentObj[key]);
      } else if (key === "dateOfDisbursement") {
        madeObj.loanDisbursementDate = moment(String(differentObj[key]), "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
      } else if (key === "lipAccNo") {
        madeObj.lipAccountNumber = differentObj[key];
      } else if (key === "coverOption") {
        madeObj.coverType = findKeysByValue(masterReducer.coverType, String(differentObj[key]));
      } else if (key === "deathSumInsured") {
        madeObj.deathSumAssured = Number(differentObj[key]);
      } else if (key === "coverTerm") {
        madeObj.policyTerm = Number(differentObj[key]);
      } else if (key === "totalPayment") {
        madeObj.totalpremium = differentObj[key];
      } else if (key === "premiumFunding") {
        madeObj.funding = findKeysByValue(masterReducer.funding, String(differentObj[key]));
      } else {
        madeObj[key] = Number(differentObj[key]);
      }
    });
  }
  return madeObj;
};

export {
  initialValues,
  existingLifeCoverInitialValuesObject,
  validationSchema,
  existingLifeCoverValidation,
  getPremiumChangeDetails
};
